import React, { useState } from 'react';
import axios from 'axios';
import styles from './Adminforgotpass.module.css'; // <-- import module.css
import config from '../../config/config';

const AdminForgotPass = () => {
  const [email, setEmail] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');

    try {
      const res = await axios.post(`${config.apiBaseUrl}/api/admin/forgot-password`, { email });
      setSuccessMsg(res.data.message);
    } catch (error) {
      if (error.response && error.response.data.message) {
        setErrorMsg(error.response.data.message);
      } else {
        setErrorMsg('Something went wrong, try again.');
      }
    }
  };

  return (
    <div className={styles.forgotPassContainer}>
      <h2>Forgot Password</h2>
      <form onSubmit={handleForgotPassword} className={styles.form}>
        {successMsg && <div className={styles.success}>{successMsg}</div>}
        {errorMsg && <div className={styles.error}>{errorMsg}</div>}

        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className={styles.input}
        />

        <button type="submit" className={styles.button}>Send Reset Link</button>
      </form>
    </div>
  );
};

export default AdminForgotPass;
